(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sajust-mega-navigation')) {
    customElements.define(
      'sajust-mega-navigation',
      class extends HTMLElement {
        constructor() {
          super();
          this.menus = [];
          this.activeMenu = null;
          this.closeTimer = null;
          this.finishTimer = null;
          this.pointerX = -1;
          this.pointerY = -1;
          this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
          this.onDocumentPointerMove = this.onDocumentPointerMove.bind(this);
          this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
          this.updateBridge = this.updateBridge.bind(this);
        }

        connectedCallback() {
          this.menus = Array.from(this.querySelectorAll('[data-sajust-mega-menu]'));
          this.menus.forEach((menu) => this.bindMenu(menu));
          document.addEventListener('pointerdown', this.onDocumentPointerDown);
          document.addEventListener('pointermove', this.onDocumentPointerMove, { passive: true });
          document.addEventListener('keydown', this.onDocumentKeyDown);
          window.addEventListener('resize', this.updateBridge, { passive: true });
          window.addEventListener('scroll', this.updateBridge, { passive: true });
        }

        disconnectedCallback() {
          document.removeEventListener('pointerdown', this.onDocumentPointerDown);
          document.removeEventListener('pointermove', this.onDocumentPointerMove);
          document.removeEventListener('keydown', this.onDocumentKeyDown);
          window.removeEventListener('resize', this.updateBridge);
          window.removeEventListener('scroll', this.updateBridge);
          window.clearTimeout(this.closeTimer);
          window.clearTimeout(this.finishTimer);
        }

        bindMenu(menu) {
          const summary = menu.querySelector('summary');
          const bridge = menu.querySelector('.sajust-mega-menu__bridge');
          const panel = menu.querySelector('.sajust-mega-menu__content');

          menu.addEventListener('toggle', () => {
            summary.setAttribute('aria-expanded', String(menu.open));
            if (menu.open) {
              this.activeMenu = menu;
              menu.classList.remove('is-closing');
              requestAnimationFrame(() => this.updateBridge());
            } else if (this.activeMenu === menu) {
              this.activeMenu = null;
            }
          });

          menu.addEventListener('pointerenter', () => {
            if (!this.hoverQuery.matches) return;
            this.cancelClose();
            this.open(menu);
          });

          menu.addEventListener('pointerleave', (event) => {
            if (!this.hoverQuery.matches) return;
            if (event.relatedTarget && menu.contains(event.relatedTarget)) return;
            this.scheduleClose(menu);
          });

          [bridge, panel].forEach((surface) => {
            surface?.addEventListener('pointerenter', () => {
              if (!this.hoverQuery.matches) return;
              this.cancelClose();
              this.open(menu);
            });

            surface?.addEventListener('pointerleave', (event) => {
              if (!this.hoverQuery.matches) return;
              if (event.relatedTarget && menu.contains(event.relatedTarget)) return;
              this.scheduleClose(menu);
            });
          });

          menu.addEventListener('focusin', (event) => {
            this.cancelClose();
            if (event.target === summary) return;
            this.open(menu);
          });

          menu.addEventListener('focusout', (event) => {
            if (!menu.contains(event.relatedTarget)) this.scheduleClose(menu, 160);
          });

          summary.addEventListener('click', () => {
            this.cancelClose();
            this.menus.forEach((other) => {
              if (other !== menu) this.close(other, true);
            });
          });
        }

        open(menu) {
          if (this.activeMenu && this.activeMenu !== menu) this.close(this.activeMenu, true);
          window.clearTimeout(this.finishTimer);
          menu.classList.remove('is-closing');
          if (!menu.open) menu.open = true;
          this.activeMenu = menu;
          requestAnimationFrame(() => this.updateBridge());
        }

        scheduleClose(menu, delay = 110) {
          this.cancelClose();
          this.closeTimer = window.setTimeout(() => {
            const pointerTarget = document.elementFromPoint(this.pointerX, this.pointerY);
            if (pointerTarget && menu.contains(pointerTarget)) return;
            this.close(menu);
          }, delay);
        }

        cancelClose() {
          window.clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }

        close(menu, immediate = false) {
          if (!menu || !menu.open) return;
          this.cancelClose();
          window.clearTimeout(this.finishTimer);

          if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            menu.classList.remove('is-closing');
            menu.open = false;
            return;
          }

          menu.classList.add('is-closing');
          this.finishTimer = window.setTimeout(() => {
            menu.open = false;
            menu.classList.remove('is-closing');
          }, 190);
        }

        updateBridge() {
          const menu = this.activeMenu;
          if (!menu || !menu.open) return;
          const summary = menu.querySelector('summary');
          const panel = menu.querySelector('.sajust-mega-menu__content');
          const bridge = menu.querySelector('.sajust-mega-menu__bridge');
          if (!summary || !panel || !bridge) return;

          const triggerRect = summary.getBoundingClientRect();
          const panelRect = panel.getBoundingClientRect();
          const gap = Math.max(0, panelRect.top - triggerRect.bottom + 2);

          bridge.style.left = `${Math.max(0, triggerRect.left - 18)}px`;
          bridge.style.top = `${triggerRect.bottom - 1}px`;
          bridge.style.width = `${triggerRect.width + 36}px`;
          bridge.style.height = `${Math.max(8, gap)}px`;
        }

        onDocumentPointerDown(event) {
          if (this.activeMenu && !this.contains(event.target)) this.close(this.activeMenu, true);
        }

        onDocumentPointerMove(event) {
          this.pointerX = event.clientX;
          this.pointerY = event.clientY;

          const menu = this.activeMenu;
          if (!menu || !menu.open || !this.hoverQuery.matches) return;

          const panel = menu.querySelector('.sajust-mega-menu__content');
          if (!panel) return;
          const panelRect = panel.getBoundingClientRect();
          const isInsidePanelVertically = event.clientY >= panelRect.top && event.clientY <= panelRect.bottom;
          if (!isInsidePanelVertically) return;

          if (event.clientX > this.getSafeHoverRight(menu)) this.close(menu);
        }

        getSafeHoverRight(menu) {
          const grid = menu.querySelector('.sajust-mega-menu__grid');
          const panel = menu.querySelector('.sajust-mega-menu__content');
          if (!grid || !panel) return window.innerWidth;

          const isCondensed = grid.classList.contains('sajust-mega-menu__grid--condensed');
          const targets = isCondensed
            ? grid.querySelectorAll('.sajust-mega-menu__level-two')
            : grid.querySelectorAll('.sajust-mega-menu__level-two span, .sajust-mega-menu__link');
          let contentRight = panel.getBoundingClientRect().left;

          targets.forEach((target) => {
            let rect;
            if (isCondensed) {
              rect = target.getBoundingClientRect();
            } else {
              const range = document.createRange();
              range.selectNodeContents(target);
              rect = range.getBoundingClientRect();
            }

            if (rect.width > 0) contentRight = Math.max(contentRight, rect.right);
          });

          return Math.min(window.innerWidth, Math.ceil(contentRight + 300));
        }

        onDocumentKeyDown(event) {
          if (event.key !== 'Escape' || !this.activeMenu) return;
          const summary = this.activeMenu.querySelector('summary');
          this.close(this.activeMenu, true);
          summary?.focus();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
